export default {
  date: 'Datum',
  chooseExpDate: 'Kies een datum',
  filterExpDate: 'Filteren op datum',
  experienceType: 'Type',
  filterExperienceType: 'Filteren op type',
  experienceVibe: 'Sfeer',
  filterExperienceVibe: 'Filteren op sfeer',
  search: 'Zoeken',
  viewCalendar: 'Kalender',
  back: 'Terug',
  previous: 'Vorige',
  next: 'Volgende',
  noExperiences: 'Geen ervaringen',
  cancelChanges: 'Wijzigingen annuleren',
  saveChanges: 'Wijzigingen opslaan',
  removeFromReservation: 'Verwijderen uit reservering',
  addToCart: 'Toevoegen aan winkelwagen',
  proceedToCheckout: 'Doorgaan naar afrekenen',
  selectDate: 'Selecteer datum',
  startDate: 'Startdatum',
  endDate: 'Einddatum',
  submit: 'Verzenden',
  filterExperienceTypeScreenReader:
    'Gebruik deze filters om de resultaten te verfijnen. Inhoud wordt automatisch bijgewerkt wanneer een filter wordt geselecteerd.',
};
